export default function(to = 10, from = 0){
  if(typeof to !== 'number' || typeof from !== 'number') return 0;
  return Math.floor(Math.random() * to) + from;
}